export default "__VITE_ASSET__DxPAz6BY__"